module.exports = __webpack_public_path__ + "static/media/S2N4-2.84458729.svg";